module.exports = __webpack_public_path__ + "media/images/flags/32/Switzerland-a15d75c3c505c699129e8708737a4c4a.png";